import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";

import { Button } from "@cpnw/ui";
import styles from "./PassportMessageForm.module.css";
import MessageItem from "components/MessageItem";
import EmptyInbox from "components/EmptyInbox";
import MessageBox from "components/MessageBox";
import { ContactTypes } from "pages/enums";
import { RequirementContainer } from "hooks/useRequirement";
import { AccountContainer } from "hooks/useAccount";
import classNames from "classnames";

export default function PassportMessageForm({ requirementType, messages = [], onSend, canMessageStudent = false, canMessageEducation = false, canMessageHealthcare = false, canMessageReviewer = false }) {
  //text area toggle
  const [textAreaOpen, setTextAreaOpen] = useState(false);
  //text area content
  const [textAreaContent, setTextAreaContent] = useState("");
  //validation min char
  const [minCharValidation] = useState(0);
  //validation errors
  const [errors, setErrors] = useState([]);
  //ref for textarea
  const replyRef = useRef(null);
  //ref for errors
  const errorsRef = useRef(null);
  //last message ref
  const lastMessageRef = useRef(null);

  const [repliedToMessage, setRepliedToMessage] = useState({});
  const numberRecentMessages = 7;
  const [showAllMessages, setShowAllMessages] = useState(false);
  const visibleMessages = showAllMessages ? messages : messages.slice(-numberRecentMessages);
  const characterLimit = 500;

  const handleChange = (event) => {
    const { value } = event.target;
    if (value.length <= characterLimit) {
      setTextAreaContent(value);
    }
  };

  const handleReplyClick = (message) => {
    setTextAreaOpen(true);
    setRepliedToMessage(message);
  };

  //use effect for scrolling text area into view if textAreaOpen is true
  useEffect(() => {
    if (textAreaOpen && replyRef.current) {
      replyRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [textAreaOpen]);

  useEffect(() => {
    if (errors && errorsRef.current) {
      errorsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [errors]);

  // useEffect(() => {
  //   if (lastMessageRef && lastMessageRef.current) {
  //     lastMessageRef.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //     });
  //   }
  // }, [lastMessageRef]);

  //this may need to be adjusted based on the values stored in the db
  //or the shape of the date objects in the db
  const getDateString = () => {
    let today = new Date();
    //date
    let month = today.getMonth() + 1;
    let date = today.getDate();
    let year = today.getFullYear();
    let currentDate = `${month}/${date}/${year}`;
    return currentDate;
  };

  //thi smay need to be adjusted based on the values stored in the db
  //or the shape of the time objects in the db
  const getTimeString = () => {
    let today = new Date();
    //time
    let hours = today.getHours();
    let minutes = today.getMinutes();
    let seconds = today.getSeconds();
    //this may need to be adjusted, (CPNW is a northwest company time zone should only be PST);
    let currentTime = `${hours}:${minutes}:${seconds} PST`;
    return currentTime;
  };

  const handleDelete = () => {
    setTextAreaContent(null);
    setTextAreaOpen(!textAreaOpen);
    //clear errors
    setErrors([]);
    setRepliedToMessage({});
  };

  const handleCancelReplyTo = (message) => {
    setRepliedToMessage(null)
  };
  const handleSendClick = (text, repliedToMessage, selectedRecipients) => {
    console.log("text", text);
    console.log("repliedToMessage", repliedToMessage);
    console.log("selectedRecipients", selectedRecipients);
    // handles traditional message send
    if (formValidation(text)) {
      //clear errors
      setErrors([]);

      onSend(text, repliedToMessage, selectedRecipients);
      setTextAreaContent("")
      setTextAreaOpen(false)
      setRepliedToMessage({});
    } else {
      //error handle here
      console.log("Errors in textarea - form not submitted");
    }
  };

  const formValidation = (content) => {
    //validate form here
    let newErrors = [];
    if (!content) {
      newErrors.push(
        `Text area must not be empty. Length must be greater than ${minCharValidation}`
      );
    } else if (content.length < minCharValidation) {
      newErrors.push(
        `Text area must contain at least ${minCharValidation} characters.`
      );
    } 
    // if(content.toLowerCase().includes('josh')) {
    //     newErrors.push('Text area must not contain the word josh')
    // }
    console.group("Errors:");
    console.log(newErrors);
    console.groupEnd();

    if (newErrors.length > 0) {
      setErrors(newErrors);
      return false;
    } else {
      return true;
    }
  };


  const renderMessageBox = (textAreaOpen) => {
    return (
      textAreaOpen && (
        <div ref={replyRef} className={styles.reply_area}>
          <MessageBox
            message=""
            repliedToMessage={repliedToMessage}
            onSend={(text, selectedOption, repliedToMessage, selectedRecipients) =>
              handleSendClick(text, selectedOption, repliedToMessage, selectedRecipients)
            }
            onClose={handleDelete}
            onCancelReplyTo={() => handleCancelReplyTo(repliedToMessage)}
            requirementType = {requirementType}
            canMessageStudent={canMessageStudent}
            canMessageEducation={canMessageEducation}
            canMessageHealthcare={canMessageHealthcare}
            canMessageReviewer={canMessageReviewer}
          />
        </div>
      )
    )
  }

  // useEffect(() => {
  //   console.log(`text area open? - ${textAreaOpen}`);
  // }, [textAreaOpen]);

  return (
    <>
      <div className={styles.message_form_container}>
        <div className={styles.message_form_container}>


          {visibleMessages.length === 0 && textAreaOpen ? (
            // 👇 No messages, but MessageBox is open
            <>
              <div className={styles.no_message_container}>
                <p>You have not received any messages yet.</p>
              </div>
              {renderMessageBox(true)}
            </>

          ) : visibleMessages.length > 0 ? (
            <>
              <h5>Messages:</h5>
              <div className={styles.message_list_container}>
                {visibleMessages.map((item, index) => (
                  <MessageItem
                    key={index}
                    message={item}
                    onReplyClick={() => handleReplyClick(item)}
                    onCancelReplyTo={() => handleCancelReplyTo(item)}
                  />
                ))}
                {messages.length > numberRecentMessages && (
                  <div className={styles.show_more_container}>
                    <a
                      className={styles.show_more_button}
                      onClick={() => setShowAllMessages(!showAllMessages)}
                    >
                      {showAllMessages ? `Show less` : `View  All Messages (${messages.length})`}
                    </a>
                  </div>
                )}


              </div>
              <div className={styles.message_box_container}>
                {renderMessageBox(true)}
              </div>
            </>
          ) : (
            // 👇 Show EmptyInbox when no messages & textArea is NOT open
            <div className={styles.no_message_container}>
              <EmptyInbox onLeaveMessageClick={() => handleReplyClick(null)} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

PassportMessageForm.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      date: PropTypes.string,
      message: PropTypes.string,
    })
  ),
  onSend: PropTypes.func.isRequired,
};

